// Angular
import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { User } from 'src/app/core/auth/_models/user.model';
import { UserService } from 'src/app/core/auth/_services';

@Component({
  selector: 'kt-patient-request-review',
  templateUrl: './patient-request-review.component.html',
  styleUrls: ['./patient-request-review.component.scss'],
})
export class PatientRequestReviewComponent implements OnInit, OnDestroy {
  // Public properties
  loaded = { user: false, images: false };
  user: User;
  subscriptions: Subscription[] = [];

  @ViewChild('cancelButton') cancelButton: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<PatientRequestReviewComponent>,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  viewLoading() {
    return Object.values(this.loaded).some((i) => i === false);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.userService.getUserById(this.data.request.requester_id).subscribe((res) => {
        this.user = res;
        this.loaded.user = true;
      }),
    );

    this.preloadImages(
      [this.data.request.previous_avatar_url, this.data.request.new_avatar_url].filter(
        (url) => url != null,
      ),
    ).then(() => {
      this.loaded.images = true;
    });
  }

  preloadImages(imageUrls: string[]): Promise<void> {
    const promises = imageUrls.map((url) => {
      return new Promise<void>((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = () => resolve();
        img.onerror = (err) => reject(err);
      });
    });
    return Promise.all(promises).then(() => undefined);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  approveRequest() {
    this.dialogRef.close({ action: 'approve' });
  }

  denyRequest() {
    this.dialogRef.close({ action: 'deny' });
  }
}
